export default __webpack_public_path__ + "static/media/teachable-feeds-slides.9df495e0.pdf";